import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NAV_DIVEDEND_TYPE,
         MAX_FILEUPLOAD_SIZE,
         Unsupported_file_format,
         Maximum_file_upload_size_should_be_10MB  } from '@root/app.constant';
import { ToastrService } from 'ngx-toastr';
import { CatalogService } from '@catalog/catalog.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { MatSelectChange } from '@angular/material/select';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-catalogue-nav-dividends',
  templateUrl: './catalogue-nav-dividends.component.html',
  styleUrls: ['./catalogue-nav-dividends.component.scss']
})
export class CatalogueNavDividendsComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  typeList = NAV_DIVEDEND_TYPE;

  file: File;

  fileName: string;

  slectedType: string;

  truncateNeeded:any;

  navDividentList = [];

  constructor(private toastr: ToastrService, 
    private catalogService: CatalogService, 
    private errorHandler: ErrorHandler) { }

  ngOnInit() {}

  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      let isValid = true;
      const fsize = this.file.size;
      const fileType = file.name.split('.').pop();
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.toastr.error(Unsupported_file_format);
        isValid = false
        this.clearFileComponent();
      }else if (fsize > MAX_FILEUPLOAD_SIZE) {
        this.toastr.error(Maximum_file_upload_size_should_be_10MB);
        isValid = false;
        this.clearFileComponent();
      }
    } else {
      this.fileName = null;
    }
  }

  private clearFileComponent(){
    this.file = null;
    setTimeout(() => {
      this.fileName = null;
    });
}

  public processData() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    if(this.truncateNeeded=='update'){
      if(this.slectedType === 'NAV'){
        this.catalogService.updateNavExcel(formData).subscribe(
          response => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readContentHistory();
            }
            this.errorHandler.handleError(response);
            this.resetData(this.slectedType);
          },
          error => {
            this.errorHandler.handleError(error);
          }
        )
      }
      else if(this.slectedType ==='Dividend'){
        // handle updated dividend
        this.catalogService.updateDividendExcel(formData).subscribe(
          response => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readContentHistory();
            }
            this.errorHandler.handleError(response);
            this.resetData(this.slectedType);
          },
          error => {
            this.errorHandler.handleError(error);
          }
        )
      }
     
    }else{
      formData.append('truncateNeeded', this.truncateNeeded)
      this.catalogService.uploadNavDividendExcel(formData, this.slectedType).subscribe(
        response => {
          if (response.status === 0) {
            this.toastr.success(response.message);
            this.readContentHistory();
          }
          this.errorHandler.handleError(response);
          this.resetData(this.slectedType);
        },
        error => {
          this.errorHandler.handleError(error);
        }
      )
    }
   
  }

  public onSelectionChange(change: MatSelectChange) {
    this.readContentHistory();
  }

  public readContentHistory() {
    const obj = {
      category: this.slectedType,
    };
    this.catalogService.readExcelContentHistory(obj).subscribe(
      (response) => {
        if(response.status === 0){
          this.navDividentList = [...response.data.list];
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public resetData(type: string){
    this.fileName = null;
    this.form.resetForm();
    setTimeout(() => {
      this.slectedType = type ? type : null;
    });
  };

}
